export function ValidCardNumberDirective(CreditCardIdentifierService, restaurantInfoFactory) {
    'ngInject';

    let data = {
        loading: true,
        isAmexAccepted: null
    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, $element, $attrs, $model) {
            Object.assign(data, {
                $scope, $element, $attrs, $model
            });

            _setAmexAvailability()
                .finally(() => data.loading = false);

            $scope.$watch(
                () => $model.$modelValue,
                newValue => {
                    CreditCardIdentifierService.cardNumber = newValue;
                    _validate(newValue);
                }
            );
        }
    };

    function _setAmexAvailability() {
        return restaurantInfoFactory.getInfo(['general'])
            .then(info => data.isAmexAccepted = info.general.isAmexAccepted);
    }

    function _checkAmex(cardNumber, cardType) {
        if (data.loading) return true; // no error if we aren't yet sure the restaurant accepts amex
        if (cardType !== 'AMEX') return true;
        return data.isAmexAccepted;
    }

    function _validate() {
        const amexValid = _checkAmex(CreditCardIdentifierService.cardNumber, CreditCardIdentifierService.name);
        const ccValid = CreditCardIdentifierService.valid;

        data.$model.$setValidity('amex', amexValid || data.$model.$pristine);

        // If amex isn't accepted, make sure to show that error first and ignore
        // whether the cc is otherwise invalid.
        if (amexValid) {
            data.$model.$setValidity('ccError', ccValid || data.$model.$pristine);
        } else {
            data.$model.$setValidity('ccError', true);
        }
    }
}
